import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {AuthProvider} from "./context";
import {LoginPage} from "./components/pages/login";
import {SessionPage} from "./components/pages/session";
import {SessionListenPage} from "./components/pages/session-listen";
import {ProtectedRoute, NonProtectedRoute, AdminRoute} from "./components/base";
import {SessionTablePage} from "./components/pages/session-table";
import { ProfileBillingPage } from './components/pages/profile-billing';
import {HomePage} from "./components/pages/home";
import { ResetPasswordPage } from './components/pages/password-reset';
import {NewPasswordPage} from "./components/pages/new-password";
import {NotFound} from "./components/layout/NotFound";
import {InternalNotFound} from "./components/layout/InternalNotFound";
import Services from "./components/pages/home/Services";
import {AdminUsersPage, AdminSessionsPage} from "./components/pages/admin";
import {SessionRunDetailsPage} from "./components/pages/session-run-details";

export function App() {
  return (
    <>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/info/services" element={<Services />} />

            <Route path="/login" element={<NonProtectedRoute><LoginPage /></NonProtectedRoute>} />
            <Route path="/reset-password" element={<NonProtectedRoute><ResetPasswordPage /></NonProtectedRoute>} />
            <Route path="/password-update" element={<NonProtectedRoute><NewPasswordPage /></NonProtectedRoute>} />

            <Route path="/panel" element={<ProtectedRoute><Navigate to="/panel/sessions" replace /></ProtectedRoute>} />

            <Route path="/panel/sessions" element={<ProtectedRoute><SessionTablePage /></ProtectedRoute>} />
            <Route path="/panel/sessions/:sessionUuid" element={<ProtectedRoute><SessionPage /></ProtectedRoute>} />
            <Route path="/panel/sessions/:sessionUuid/runs/:runId" element={<ProtectedRoute><SessionRunDetailsPage /></ProtectedRoute>} />
            {/* both authenticated and non-authenticated users should have access to this routes */}
            <Route path="/panel/sessions/:sessionUuid/listen" element={<SessionListenPage />} />

            <Route path="/panel/profile" element={<ProtectedRoute><ProfileBillingPage /></ProtectedRoute>} />
            <Route path="/panel/not-found" element={<ProtectedRoute><InternalNotFound /></ProtectedRoute>} />
            <Route path="/panel/*" element={<ProtectedRoute><InternalNotFound /></ProtectedRoute>} />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminRoute><Navigate to="/admin/users" replace /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute><AdminUsersPage /></AdminRoute>} />
            <Route path="/admin/sessions" element={<AdminRoute><AdminSessionsPage /></AdminRoute>} />

            {/* both authenticated and non-authenticated users should have access to this routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </AuthProvider>
    </>
  );
}
